import {
  TIPO_ANAGRAFICA_CLIENTE_PF_KEY,
  TIPO_ANAGRAFICA_CLIENTE_PG_KEY,
} from "../constants/baseTableKeys.js";

const normalizeIdentifier = (value) => String(value ?? "").replace(/\s/g, "").toUpperCase();

export const matchesSearchSubjectType = (isPg, isDI, selectedValue) =>
  selectedValue === "PF" ? !isPg : !!isPg && (selectedValue === "DI" ? isDI : !isDI);

export const findClientFascicolo = (relations = [], aziendaId) =>
  relations.find((relation) =>
    String(relation.fascicolo?.AziendaId) === String(aziendaId) &&
    [TIPO_ANAGRAFICA_CLIENTE_PF_KEY, TIPO_ANAGRAFICA_CLIENTE_PG_KEY].includes(
      relation.base_tipo_anagrafica?.Key
    )
  )?.fascicolo ?? null;

export const getExistingRowFascicolo = (row) =>
  row?.meta?.isOfSameAzienda && row.meta.fascicolo?.id > 0
    ? row.meta.fascicolo
    : null;

export const isSameSearchSubject = (first, second) => {
  if (first.isPg !== second.isPg) return false;
  const firstWorkspaceId = first.anagrafica?.workspaceId;
  const secondWorkspaceId = second.anagrafica?.workspaceId;
  if (firstWorkspaceId && secondWorkspaceId && firstWorkspaceId === secondWorkspaceId) return true;
  const firstCf = normalizeIdentifier(first.codiceFiscale);
  const secondCf = normalizeIdentifier(second.codiceFiscale);
  if (firstCf && secondCf) return firstCf === secondCf;
  const firstPIva = normalizeIdentifier(first.partitaIva);
  const secondPIva = normalizeIdentifier(second.partitaIva);
  return !!firstPIva && !!secondPIva && firstPIva === secondPIva;
};

export const excludeExistingSearchRows = (rows, existingRows = []) => {
  const accepted = [];
  for (const row of rows) {
    if (!existingRows.some((existing) => isSameSearchSubject(existing, row)) &&
        !accepted.some((existing) => isSameSearchSubject(existing, row))) {
      accepted.push(row);
    }
  }
  return accepted;
};